export const SET_CUSTOMERS_LIST = "SET_CUSTOMERS_LIST";
